module.exports = __webpack_public_path__ + "static/media/pwcrack.5f604eda.jpeg";